import { render, staticRenderFns } from "./navbar.vue?vue&type=template&id=67097aaa&"
import script from "./navbar.vue?vue&type=script&lang=js&"
export * from "./navbar.vue?vue&type=script&lang=js&"
import style0 from "./navbar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports